"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _webPkiFixed = _interopRequireDefault(require("web-pki-fixed"));
var _reactFacebookLogin = _interopRequireDefault(require("react-facebook-login"));
var _Govbr = _interopRequireDefault(require("../../../@assets/images/Govbr.svg"));
var _material = require("@mui/material");
var _functions = require("../../../@functions");
var _constants = require("../../../@constants");
var _env = require("../../../@constants/env");
var _hooks = require("../../../@hooks");
var _google = require("@react-oauth/google");
var _reactLinkedinLoginOauth = require("react-linkedin-login-oauth2");
var _reactSocialLoginButtons = require("react-social-login-buttons");
var _TabContext = require("../contexts/TabContext");
var _AuthContext = require("../contexts/AuthContext");
var _ExternalAuthContext = require("../contexts/ExternalAuthContext");
var _TextInput = _interopRequireDefault(require("../../../@custom/TextInput"));
var _SimpleButton = _interopRequireDefault(require("../../../@custom/SimpleButton"));
var _Icon = _interopRequireDefault(require("../../../@custom/Icon"));
var _InboxRequest = _interopRequireDefault(require("../../../@custom/InboxRequest"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @typedef CertificateModel
 * @type {import("web-pki-fixed").CertificateModel}
 */

function Login() {
  var _errorMsgs$email, _errorMsgs$password, _errorMsgs$other;
  var _useAuth = (0, _AuthContext.useAuth)(),
    app = _useAuth.app,
    showMessage = _useAuth.showMessage,
    showSpinner = _useAuth.showSpinner,
    hideSpinner = _useAuth.hideSpinner,
    loginWithEmail = _useAuth.loginWithEmail,
    loginWithGoogle = _useAuth.loginWithGoogle,
    loginWithLinkedIn = _useAuth.loginWithLinkedIn,
    loginWithFacebook = _useAuth.loginWithFacebook,
    loginWithCertificate = _useAuth.loginWithCertificate,
    logout = _useAuth.logout;
  var queryParams = (0, _hooks.useQueryParams)();
  var _useExternalAuth = (0, _ExternalAuthContext.useExternalAuth)(),
    external = _useExternalAuth.external,
    loading = _useExternalAuth.loading;
  var _useWorkfluxPortal = (0, _hooks.useWorkfluxPortal)(),
    portalDomain = _useWorkfluxPortal.portalDomain;
  var _useContext = (0, _react.useContext)(_TabContext.TabContext),
    setTab = _useContext.setTab;
  var _useErrors = (0, _hooks.useErrors)(),
    errorMsgs = _useErrors.errorMsgs,
    addErrorMsg = _useErrors.addErrorMsg,
    removeErrorMsg = _useErrors.removeErrorMsg,
    cleanAllErrors = _useErrors.cleanAllErrors;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    icpBrAuth = _useState2[0],
    setIcpBrAuth = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    email = _useState4[0],
    setEmail = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    password = _useState6[0],
    setPassword = _useState6[1];

  /** @type {[LacunaWebPKI | undefined, React.Dispatch<React.SetStateAction<LacunaWebPKI | undefined>>]} */
  var _useState7 = (0, _react.useState)(),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    pki = _useState8[0],
    setPki = _useState8[1];
  /** @type {[CertificateModel[], React.Dispatch<React.SetStateAction<CertificateModel[]>>]} */
  var _useState9 = (0, _react.useState)([]),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    pkiCertificates = _useState10[0],
    setPkiCertificates = _useState10[1];
  /** @type {[CertificateModel | undefined, React.Dispatch<React.SetStateAction<CertificateModel | undefined>>]} */
  var _useState11 = (0, _react.useState)(),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    selectedCertificate = _useState12[0],
    setSelectedCertificate = _useState12[1];
  var _useState13 = (0, _react.useState)(''),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    cpf = _useState14[0],
    setCpf = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    rememberMe = _useState16[0],
    setRememberMe = _useState16[1];
  var isPortal = app === 'workflux-portal';
  var loginTitle = _constants.loginPageConstants[app].title;
  var loginSubtitle = _constants.loginPageConstants[app].subtitle;
  var linkedInRedirectUrl = "".concat(window.location.origin, "/linkedin");
  var _useMemo = (0, _react.useMemo)(function () {
      return {
        hasLoginGoogle: !!loginWithGoogle,
        hasLoginLinkedIn: !!loginWithLinkedIn,
        hasLoginFacebook: !!loginWithFacebook
      };
    }),
    hasLoginFacebook = _useMemo.hasLoginFacebook,
    hasLoginGoogle = _useMemo.hasLoginGoogle,
    hasLoginLinkedIn = _useMemo.hasLoginLinkedIn;

  /** @param {any} err */
  var handleError = function handleError(err) {
    var _err$response;
    var response = (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.data;
    if (response === 'user-email-not-verified') {
      return setTab('redefinePassword', {
        email: email,
        oldPassword: password
      });
    }
    if (passwordErrors[response]) {
      addErrorMsg('password', passwordErrors[response]);
    } else if (emailErrors[response]) {
      addErrorMsg('email', emailErrors[response]);
    } else if (otherErrors[response]) {
      addErrorMsg('other', otherErrors[response]);
    } else {
      showMessage('Erro ao fazer Login', /*#__PURE__*/_react["default"].createElement(_InboxRequest["default"], {
        error: err,
        additionalInfo: {
          email: email,
          rememberMe: rememberMe
        }
      }));
    }
  };
  var handleLogin = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var belongsToUser, appKeyTokenJson, token, _loginResponse$appKey, loginResponse, _loginResponse$appKey2, _loginResponse, redirectTo, redirectUrl;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!icpBrAuth) {
              _context.next = 22;
              break;
            }
            if (cpf) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return", addErrorMsg('other', otherErrors['missing-cpf']));
          case 5:
            removeErrorMsg('other', otherErrors['missing-cpf']);
          case 6:
            if (_functions.validator.cpf(cpf)) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", addErrorMsg('other', otherErrors['invalid-cpf']));
          case 10:
            removeErrorMsg('other', otherErrors['invalid-cpf']);
          case 11:
            if (selectedCertificate) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return", addErrorMsg('other', otherErrors['cert-not-selected']));
          case 15:
            removeErrorMsg('other', otherErrors['cert-not-selected']);
          case 16:
            belongsToUser = selectedCertificate.pkiBrazil.cpf.replace(/\D/g, '') === cpf.replace(/\D/g, '');
            if (belongsToUser) {
              _context.next = 21;
              break;
            }
            return _context.abrupt("return", addErrorMsg('other', otherErrors['cpf-cert-not-match']));
          case 21:
            removeErrorMsg('other', otherErrors['cpf-cert-not-match']);
          case 22:
            showSpinner();
            appKeyTokenJson = {
              'appcenter-customer': 'appCenterToken',
              collectame: 'collectameToken',
              dokia: 'dokiaNewtonToken',
              indexia: '',
              workflux: 'workfluxToken',
              'workflux-portal': 'workfluxToken'
            };
            _context.prev = 24;
            token = ''; // let user = {}
            if (icpBrAuth) {
              _context.next = 33;
              break;
            }
            _context.next = 29;
            return loginWithEmail(email, password);
          case 29:
            loginResponse = _context.sent;
            // user = loginResponse.user
            token = (_loginResponse$appKey = loginResponse[appKeyTokenJson[app]]) !== null && _loginResponse$appKey !== void 0 ? _loginResponse$appKey : '';

            /*if (rememberMe) {
            	/** @type {string} 
            	const userUid = auth.user.uid
            	/** @type {string} 
            	const companyUid = auth.user.currentCompany.uid
            		const { data } = await appcenterApi.auth.createSSOToken(userUid, companyUid, app)
            	const { uid: token } = data
            		setRememberMeToken(app, token)
            } else {
            	removeRememberMeToken(app)
            }*/
            _context.next = 37;
            break;
          case 33:
            _context.next = 35;
            return loginWithCertificate(cpf, selectedCertificate);
          case 35:
            _loginResponse = _context.sent;
            // user = loginResponse.user
            token = (_loginResponse$appKey2 = _loginResponse[appKeyTokenJson[app]]) !== null && _loginResponse$appKey2 !== void 0 ? _loginResponse$appKey2 : '';
          case 37:
            redirectTo = queryParams.redirectTo;
            if (!redirectTo) {
              _context.next = 42;
              break;
            }
            redirectUrl = "".concat(redirectTo, "?token=").concat(token);
            window.location.href = redirectUrl;
            return _context.abrupt("return");
          case 42:
            cleanAllErrors();
            _context.next = 50;
            break;
          case 45:
            _context.prev = 45;
            _context.t0 = _context["catch"](24);
            _context.next = 49;
            return logout();
          case 49:
            handleError(_context.t0);
          case 50:
            _context.prev = 50;
            hideSpinner();
            return _context.finish(50);
          case 53:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[24, 45, 50, 53]]);
    }));
    return function handleLogin() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleLoginGoogle = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2) {
      var credential;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            credential = _ref2.credential;
            if (loginWithGoogle) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return", alert('Metódo de login não disponível.'));
          case 3:
            _context2.next = 5;
            return loginWithGoogle(credential, portalDomain.company);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleLoginGoogle(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var _useLinkedIn = (0, _reactLinkedinLoginOauth.useLinkedIn)({
      clientId: _env.linkedInClientID,
      redirectUri: linkedInRedirectUrl,
      scope: 'profile email openid',
      onSuccess: function () {
        var _onSuccess = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(code) {
          return _regenerator["default"].wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (loginWithLinkedIn) {
                  _context3.next = 2;
                  break;
                }
                return _context3.abrupt("return", alert('Metódo de login não disponível.'));
              case 2:
                _context3.next = 4;
                return loginWithLinkedIn(code, portalDomain.company);
              case 4:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function onSuccess(_x2) {
          return _onSuccess.apply(this, arguments);
        }
        return onSuccess;
      }(),
      onError: function onError(error) {
        console.log(error);
      }
    }),
    linkedInLogin = _useLinkedIn.linkedInLogin;
  var handleLoginFacebook = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(response) {
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function handleLoginFacebook(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    if (!icpBrAuth || pki) return;
    setPki(new _webPkiFixed["default"]());
  }, [icpBrAuth, pki]);
  (0, _react.useEffect)(function () {
    if (!pki) return;
    var listCertificates = function listCertificates() {
      pki.listCertificates().success(function (certs) {
        setPkiCertificates((0, _toConsumableArray2["default"])(certs));
      });
    };
    pki.init({
      ready: listCertificates
    });
  }, [pki]);
  if (loading) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form-textBox"
  }, /*#__PURE__*/_react["default"].createElement("h1", null, loginTitle), /*#__PURE__*/_react["default"].createElement("p", null, loginSubtitle)), !icpBrAuth ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    required: true,
    className: "Auth-right-form-textInput",
    label: "Email",
    placeholder: "exemplo@gmail.com",
    onChange: function onChange(evt) {
      return setEmail(evt.target.value);
    },
    value: email
  }), ((_errorMsgs$email = errorMsgs.email) === null || _errorMsgs$email === void 0 ? void 0 : _errorMsgs$email.length) > 0 && errorMsgs.email.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, ' ', "* ", msg);
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    required: true,
    label: "Senha",
    placeholder: "1234",
    onEnterPress: handleLogin,
    onChange: function onChange(evt) {
      return setPassword(evt.target.value);
    },
    value: password,
    isPassword: true
  }), ((_errorMsgs$password = errorMsgs.password) === null || _errorMsgs$password === void 0 ? void 0 : _errorMsgs$password.length) > 0 && errorMsgs.password.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, ' ', "* ", msg);
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    className: "Auth-right-form-textInput",
    label: "CPF",
    mask: "999.999.999-99",
    placeholder: "123.456.789-01",
    onChange: function onChange(evt) {
      return setCpf(evt.target.value);
    },
    value: cpf
  }), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    select: true,
    variant: "outlined",
    label: "Certificados",
    onChange: function onChange(evt) {
      return setSelectedCertificate(evt.target.value);
    },
    value: selectedCertificate
  }, pkiCertificates.map(function (certificate) {
    var expired = certificate.validityEnd < new Date();
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: certificate.thumbprint,
      value: certificate,
      disabled: expired
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        overflowX: 'auto',
        maxWidth: 350
      }
    }, /*#__PURE__*/_react["default"].createElement("p", null, certificate.pkiBrazil.certificateType, " - ", certificate.subjectName), /*#__PURE__*/_react["default"].createElement("p", null, certificate.issuerName), expired && /*#__PURE__*/_react["default"].createElement("p", null, "(Expirado)")));
  }))), /*#__PURE__*/_react["default"].createElement(_material.FormGroup, {
    row: true,
    style: {
      margin: '10px 0'
    }
  }, !icpBrAuth ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-link",
    onClick: function onClick() {
      return setIcpBrAuth(true);
    },
    style: {
      transform: 'translateY(8px)'
    }
  }, "Entrar com certificado digital"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-link",
    onClick: function onClick() {
      return setTab('forgotPassword');
    },
    style: {
      transform: 'translateY(8px)'
    }
  }, "Esqueci a senha")) : /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-link",
    onClick: function onClick() {
      return setIcpBrAuth(false);
    }
  }, "Entrar com email e senha")), ((_errorMsgs$other = errorMsgs.other) === null || _errorMsgs$other === void 0 ? void 0 : _errorMsgs$other.length) > 0 && errorMsgs.other.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, ' ', "* ", msg);
  }), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    fullWidth: true,
    onClick: handleLogin
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Entrar"), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faPenAlt"
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Auth-right-form-centeredText"
  }, "Novo por aqui?", ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-link",
    onClick: function onClick() {
      return setTab(external ? 'externalRegister' : 'register');
    }
  }, "Cadastre-se")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Auth-right-form-buttons"
  }, hasLoginGoogle && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_google.GoogleLogin, {
    clientId: _env.googleClientID,
    onSuccess: handleLoginGoogle,
    cookiePolicy: "single_host_origin",
    auto_select: false,
    width: "100%",
    text: "signin_with",
    logo_alignment: "left"
  }), /*#__PURE__*/_react["default"].createElement(_reactSocialLoginButtons.GoogleLoginButton, {
    className: "Auth-right-form-buttons-google"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Entrar com Google"))), hasLoginLinkedIn && /*#__PURE__*/_react["default"].createElement(_reactSocialLoginButtons.LinkedInLoginButton, {
    className: "Auth-right-form-buttons-linkedIn",
    onClick: linkedInLogin
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Entrar com LinkedIn")), hasLoginFacebook && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactFacebookLogin["default"], {
    appId: _env.facebookClientID,
    callback: handleLoginFacebook,
    cssClass: "externalLoginFacebook"
  }), /*#__PURE__*/_react["default"].createElement(_reactSocialLoginButtons.FacebookLoginButton, {
    className: "Auth-right-form-buttons-facebook"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Entrar com Facebook"))), isPortal && /*#__PURE__*/_react["default"].createElement(_material.Button, {
    variant: "contained",
    className: "Auth-right-form-buttons-govbr"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _Govbr["default"]
  }), /*#__PURE__*/_react["default"].createElement("span", null, "Entrar com gov.com"))));
}
var _default = Login;
exports["default"] = _default;
var passwordErrors = {
  'wrong-password': 'Senha incorreta'
};
var emailErrors = {
  'user-not-found': 'Email incorreto',
  'user-blocked': 'Seu acesso foi bloqueado por questões contratuais, por favor entre em contato com a franqueadora para esclarecer suas dúvidas e reaver seu acesso',
  'sso-user-is-not-in-app': 'Você não tem acesso a este app',
  'user-email-not-verified': 'Email não verificado'
};
var otherErrors = {
  'suitable-license-not-found': 'Seu acesso foi bloqueado, devido a alguma irregularidade nas licenças do seu plano. Contate o suporte para saber mais.',
  'user-blocked': 'Usuário bloqueado',
  'franchisee-blocked': 'Franquia bloqueada',
  'company-blocked': 'Empresa bloqueada',
  'user-is-inactive': 'Email incorreto',
  'missing-cpf': 'O campo CPF é obrigatório',
  'invalid-cpf': 'CPF inválido',
  'cert-not-selected': 'Por favor, selecione um certificado',
  'cpf-cert-not-match': 'Esse certificado não pertence à pessoa física do CPF',
  'icp-brasil-auth-not-enabled': 'Esse usuário não habilitou autenticação por certificado digital'
};